import { useQuery } from 'react-query';
import { format } from 'date-fns';
import { getWithdrawRequests, IWithdrawRequestsParams } from '../api/withdraw';
import { useState } from 'react';
import { IWithdrawRequest } from '../types/IWithdrawRequest';
import { MONTH_FORMAT, QueryKeys, TIME_FORMAT } from '../constants';

interface IWithdrawRequestByDate {
    date: string;
    values: IWithdrawRequest[];
}

interface IUseWithdrawRequestsGroupByDateResult {
    withdrawRequests: IWithdrawRequestByDate[];
    isLoading: boolean;
}

export function useGetWithdrawRequestsGroupByDate(
    params: IWithdrawRequestsParams
): IUseWithdrawRequestsGroupByDateResult {
    const [withdrawRequests, setWithdrawRequests] = useState<IWithdrawRequestByDate[]>([]);

    const { isLoading } = useQuery(
        [QueryKeys.withdrawRequests, params.pageNumber, params.pageSize, params.userId],
        () => getWithdrawRequests(params),
        {
            onSuccess(res) {
                if (res && res.entities && res.entities.length > 0) {
                    const withdrawRequestsByDate: IWithdrawRequestByDate[] = withdrawRequests ?? [];
                    res.entities.forEach((withdrawRequest) => {
                        let withdrawRequestIdx = -1;
                        if (withdrawRequestsByDate.length > 0) {
                            withdrawRequestIdx = withdrawRequestsByDate.findIndex(
                                (req) => req.date === format(new Date(withdrawRequest.createdAt), MONTH_FORMAT)
                            );
                        }

                        if (withdrawRequestIdx === -1) {
                            withdrawRequestsByDate.push({
                                date: format(new Date(withdrawRequest.createdAt), MONTH_FORMAT),
                                values: [
                                    {
                                        ...withdrawRequest,
                                        createdAt: format(new Date(withdrawRequest.createdAt), TIME_FORMAT),
                                    },
                                ],
                            });
                        } else {
                            withdrawRequestsByDate[withdrawRequestIdx] = {
                                ...withdrawRequestsByDate[withdrawRequestIdx],
                                values: withdrawRequestsByDate[withdrawRequestIdx].values.concat({
                                    ...withdrawRequest,
                                    createdAt: format(new Date(withdrawRequest.createdAt), TIME_FORMAT),
                                }),
                            };
                        }
                    });
                    setWithdrawRequests(withdrawRequestsByDate);
                }
            },
        }
    );

    return { withdrawRequests, isLoading };
}
